export const SITE_URL = "https://abnails.fr";
export const SITE_NAME = "AB Nails";
export const CONTACT_EMAIL = "info@abnails.fr";

export const IMAGES = {
  hero: {
    src: "https://images.pexels.com/photos/6941115/pexels-photo-6941115.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    width: 940,
    height: 650,
    alt: "Mains soignées avec une manucure nude professionnelle — visuel d'illustration",
  },
  prep: {
    src: "https://images.pexels.com/photos/37033378/pexels-photo-37033378.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    width: 940,
    height: 650,
    alt: "Préparation de l'ongle avant la pose de gel — visuel d'illustration",
  },
  fraises: {
    src: "https://images.pexels.com/photos/4677843/pexels-photo-4677843.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    width: 940,
    height: 650,
    alt: "Embouts et fraises professionnels pour ponceuse à ongles — visuel d'illustration",
  },
  nailart: {
    src: "https://images.pexels.com/photos/39272726/pexels-photo-39272726.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    width: 940,
    height: 650,
    alt: "Détail de nail art scintillant sur ongles — visuel d'illustration",
  },
  nude: {
    src: "https://images.pexels.com/photos/17280274/pexels-photo-17280274.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    width: 940,
    height: 650,
    alt: "Finition nude élégante d'une pose de gel — visuel d'illustration",
  },
  texture: {
    src: "https://images.unsplash.com/photo-1645785328791-64e8ff28edcd?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    width: 940,
    height: 627,
    alt: "Texture crème d'un gel nude en studio — visuel d'illustration",
  },
  pour: {
    src: "https://images.unsplash.com/photo-1640958903443-1e49d720650d?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    width: 940,
    height: 627,
    alt: "Gel nude coulé en studio, texture dense — visuel d'illustration",
  },
};

export const NAV = [
  { to: "/", label: "Accueil", testid: "nav-accueil" },
  { to: "/produits/", label: "Produits", testid: "nav-produits" },
  { to: "/protocole/", label: "Protocole", testid: "nav-protocole" },
  { to: "/a-propos/", label: "À propos", testid: "nav-a-propos" },
  { to: "/faq/", label: "FAQ", testid: "nav-faq" },
];

export const CATEGORIES = [
  { id: "gels", label: "Gels de construction" },
  { id: "bases", label: "Bases & top coats" },
  { id: "vernis", label: "Vernis semi-permanent" },
  { id: "fraises", label: "Fraises & embouts" },
  { id: "nailart", label: "Nail art" },
];

export const PRODUCTS = [
  {
    id: "framework-gel",
    cat: "gels",
    name: "Framework Gel — American Creator",
    desc: "Gel de construction teinté pour l'architecture de l'ongle. Décliné dans une palette de teintes nude : Almondine, Fawn, Lilly, Clear et d'autres nuances.",
    tags: ["30 ml", "Teintes nude", "Catalyse 60 s"],
  },
  {
    id: "construction-gel",
    cat: "gels",
    name: "Construction Gel — American Creator",
    desc: "Gel de construction pour le renforcement, la réparation et le modelage de l'ongle. Disponible notamment en teinte Beige Pink.",
    tags: ["15 ml", "Beige Pink", "Catalyse 60 s"],
  },
  {
    id: "base-gel",
    cat: "bases",
    name: "Base Gel & Base Gel Mild",
    desc: "Base dense recommandée avant l'application du gel de construction, après dégraissage de la plaque. Version Mild pour les ongles plus sensibles.",
    tags: ["Base dense", "Sans primer", "30–60 s UV/LED"],
  },
  {
    id: "top-coat",
    cat: "bases",
    name: "Top coat de finition",
    desc: "Dernière étape du protocole : scelle le gel couleur et apporte la finition brillante de la pose.",
    tags: ["Finition", "Brillance"],
  },
  {
    id: "vernis-semi",
    cat: "vernis",
    name: "Vernis semi-permanent",
    desc: "Gels couleur appliqués après l'architecture, avant le top coat. Bases dédiées au vernis semi-permanent également disponibles.",
    tags: ["Gel couleur", "Après architecture"],
  },
  {
    id: "fraise-cone-blue",
    cat: "fraises",
    name: "Fraise diamant Cone Blue (réf. 115493)",
    desc: "Embout diamant KMIZ de 1,4 mm de diamètre, conçu pour le nettoyage des cuticules et la préparation de la plaque unguéale.",
    tags: ["Ø 1,4 mm", "KMIZ", "20 000–25 000 tr/min"],
  },
  {
    id: "fraises-pro",
    cat: "fraises",
    name: "Fraises diamant & carbure",
    desc: "Sélection d'embouts de qualité professionnelle pour la manucure et la pédicure : préparation, dépose et finitions à la ponceuse.",
    tags: ["Diamant", "Carbure", "Pro"],
  },
  {
    id: "stickers-sliders",
    cat: "nailart",
    name: "Stickers & sliders nail art",
    desc: "Autocollants et sliders pour des décors rapides et précis, dont la gamme Lak de Coeur et des modèles dédiés à la pédicure.",
    tags: ["Sliders", "Autocollants", "Pédicure"],
  },
];

export const PROTOCOL_STEPS = [
  {
    n: "01",
    title: "Préparation de la plaque",
    desc: "Manucure russe : nettoyage des cuticules et de la plaque unguéale à la fraise diamant, pour une surface de travail parfaitement propre.",
    tag: "Fraise diamant",
  },
  {
    n: "02",
    title: "Dégraissage",
    desc: "Dégraissage soigneux de l'ongle, sans primer, conformément au protocole recommandé pour les gels American Creator.",
    tag: "Sans primer",
  },
  {
    n: "03",
    title: "Base dense",
    desc: "Application d'une couche dense de Base Gel (ou Base Gel Mild), puis catalysation sous lampe UV/LED.",
    tag: "30–60 s UV/LED",
  },
  {
    n: "04",
    title: "Architecture",
    desc: "Construction de l'architecture de l'ongle au gel de construction (Framework Gel ou Construction Gel), puis catalysation.",
    tag: "60 s UV/LED",
  },
  {
    n: "05",
    title: "Couleur",
    desc: "Application du gel couleur ou du vernis semi-permanent de votre choix sur l'architecture catalysée.",
    tag: "Gel couleur",
  },
  {
    n: "06",
    title: "Finition",
    desc: "Top coat de finition pour sceller la pose et obtenir une brillance durable.",
    tag: "Top coat",
  },
];

export const FAQS = [
  {
    q: "À qui s'adressent les produits AB Nails ?",
    a: "AB Nails est une boutique en ligne spécialisée dans les produits à usage professionnel : gels de construction, vernis semi-permanents, fraises et embouts de ponceuse, accessoires de nail art. Elle s'adresse en priorité aux prothésistes ongulaires et aux professionnels de la manucure.",
  },
  {
    q: "Quelles marques retrouve-t-on sur AB Nails ?",
    a: "La boutique propose notamment les produits American Creator, une marque américaine créée en 2014 et dédiée aux professionnels de l'ongle, dont les formules sont présentées comme hypoallergéniques, cruelty-free et vegan.",
  },
  {
    q: "Quels sont les temps de catalysation recommandés ?",
    a: "Selon le protocole d'application : 30 à 60 secondes sous lampe UV/LED pour la base, puis 60 secondes pour le gel de construction. Référez-vous toujours à la fiche de chaque référence.",
  },
  {
    q: "Comment utiliser la fraise diamant Cone Blue (réf. 115493) ?",
    a: "Cet embout KMIZ de 1,4 mm de diamètre s'utilise pour le nettoyage des cuticules et la préparation de la plaque unguéale, à une vitesse optimale de 20 000 à 25 000 tours par minute.",
  },
  {
    q: "Comment connaître les prix et la disponibilité des références ?",
    a: "Le catalogue évolue régulièrement et certaines références peuvent être temporairement indisponibles. Écrivez-nous à info@abnails.fr : nous vous répondrons avec les références et tarifs en cours.",
  },
  {
    q: "AB Nails dispose-t-elle d'un salon ou d'une boutique physique ?",
    a: "Non : AB Nails est une boutique en ligne. Toutes les demandes — commandes, conseils produits, questions — se font par e-mail à info@abnails.fr.",
  },
];

export const ROUTES = [
  {
    path: "/",
    title: "AB Nails — Produits professionnels pour ongles | Boutique en ligne",
    description:
      "AB Nails, boutique en ligne française de produits professionnels pour ongles : gels de construction, vernis semi-permanent, fraises et nail art, dont la gamme American Creator.",
  },
  {
    path: "/produits/",
    title: "Produits professionnels pour ongles — Gels, vernis, fraises | AB Nails",
    description:
      "Gels de construction, bases et top coats, vernis semi-permanent, fraises diamant et carbure, nail art : découvrez les gammes professionnelles de la boutique AB Nails.",
  },
  {
    path: "/protocole/",
    title: "Protocole d'application des gels — Manucure russe | AB Nails",
    description:
      "Préparation à la fraise diamant, dégraissage sans primer, base dense, architecture au gel de construction : le protocole d'application pas à pas pour les gels American Creator.",
  },
  {
    path: "/a-propos/",
    title: "À propos — AB Nails, boutique de produits ongulaires professionnels",
    description:
      "AB Nails est une boutique en ligne française dédiée aux prothésistes ongulaires, qui propose notamment les produits professionnels de la marque American Creator.",
  },
  {
    path: "/contact/",
    title: "Contact — AB Nails",
    description:
      "Une question sur une référence, une commande ou un conseil produit ? Contactez la boutique AB Nails par e-mail à info@abnails.fr.",
  },
  {
    path: "/faq/",
    title: "FAQ — Questions fréquentes sur les produits | AB Nails",
    description:
      "Temps de catalysation, utilisation des fraises diamant, marques proposées, commande : les réponses aux questions fréquentes des prothésistes ongulaires.",
  },
];

export const breadcrumbJsonLd = (path, label) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Accueil", item: `${SITE_URL}/` },
    ...(path === "/"
      ? []
      : [{ "@type": "ListItem", position: 2, name: label, item: `${SITE_URL}${path}` }]),
  ],
});

export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: `${SITE_URL}/`,
  email: CONTACT_EMAIL,
  logo: `${SITE_URL}/favicon.svg`,
};

export const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_NAME,
  url: `${SITE_URL}/`,
  inLanguage: "fr-FR",
};

export const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};
